import React from 'react';
import { StatusContainer, StatusWrapper, StyledIcon } from './styles';

import { DISCHARGE_STATUS } from '../../../../constants';

const _getStatusIcon = status => {
  if (
    status === DISCHARGE_STATUS.DENIED_WITH_PICTURE ||
    status === DISCHARGE_STATUS.PARTIAL_WITH_PICTURE ||
    status === DISCHARGE_STATUS.TOTAL_WITH_PICTURE
  ) {
    return {
      color: '#263465',
      icon: 'with-image',
    };
  }

  return {
    color: '#BBBBBB',
    icon: 'no-image',
  };
};

const _getStatusFlag = status => {
  if (
    status === DISCHARGE_STATUS.TOTAL_WITH_PICTURE ||
    status === DISCHARGE_STATUS.TOTAL_WITHOUT_PICTURE
  ) {
    return (
      <StatusContainer backgroundColor="#00AA00">
        <span>T</span>
      </StatusContainer>
    );
  }

  if (
    status === DISCHARGE_STATUS.PARTIAL_WITH_PICTURE ||
    status === DISCHARGE_STATUS.PARTIAL_WITHOUT_PICTURE
  ) {
    return (
      <StatusContainer backgroundColor="#FFAA00">
        <span>P</span>
      </StatusContainer>
    );
  }

  if (
    status === DISCHARGE_STATUS.DENIED_WITH_PICTURE ||
    status === DISCHARGE_STATUS.DENIED_WITHOUT_PICTURE
  ) {
    return (
      <StatusContainer backgroundColor="#EE0020">
        <span>R</span>
      </StatusContainer>
    );
  }
};

const StatusColumn = ({ status }) => {
  const statusIcon = _getStatusIcon(status);

  return (
    <StatusWrapper>
      {_getStatusFlag(status)}
      <StyledIcon color={statusIcon.color} name={statusIcon.icon} />
    </StatusWrapper>
  );
};

export default StatusColumn;
